
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions/[...slug]",
      function () {
        return require("private-next-pages/questions/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questions/[...slug]"])
      });
    }
  